<template>
    <div>
        <v-row
            justify="start"
            :no-gutters="$vuetify.breakpoint.smAndUp"
            :class="{ 'px-3': $vuetify.breakpoint.smAndUp }"
            class="pb-2"
        >
            <v-chip-group v-model="selection"
                ><v-chip
                    v-for="(chip, name, idx) in selects"
                    v-model="chip.show"
                    :close="!!(chip.clearable && form[name])"
                    close-icon="clear"
                    @click:close="[(form[name] = null), resetOptions()]"
                    :value="chip.name"
                    :key="chip.name"
                    :id="chip.name"
                    outlined
                    small
                    :disabled="chip.disabled"
                    :class="[
                        //'primary primary--text v-chip--outlined shadow-blue',
                        'font-weight-bold v-chip--outlined soli-grey',
                        idx == 0 && $vuetify.breakpoint.xs ? 'ml-6' : 'mx-1',
                        idx == Object.keys(selects).length - 1 &&
                        $vuetify.breakpoint.xs
                            ? 'mr-6'
                            : 'mx-1',
                        idx == 1 && !form.instrument ? 'hide' : null,
                    ]"
                    :ripple="false"
                    >{{ chip.display() }}</v-chip
                ></v-chip-group
            >
        </v-row>

        <SoliDateScroll
            v-if="form.instrument"
            ref="date"
            :error="errors.starts_at"
            :future="true"
            :events="searchAssignments.map((e) => globalMomentYMD(e.starts_at))"
            :select="false"
            :intervals="assignmentIntervals"
            :intervalsLoading="apiLoading"
            :loading="assignmentsLoading"
            :selectedInstrument="form.instrument?.id"
            :selectedLocation="form.location"
            :floating="false"
            @input="selectDate($event)"
            @inputTime="selectTime($event)"
            v-model="form.startDate"
            simStudentView
        />

        <v-container v-if="!form.instrument"
            ><v-btn
                block
                outlined
                rounded
                color="#e0e0e0"
                @click="
                    [
                        (selects['instrument'].show = true),
                        (selection = 'instrument'),
                    ]
                "
                ><div class="soli-grey flex align-center justify-center">
                    Instrument <v-icon right>keyboard_arrow_down</v-icon>
                </div>
            </v-btn></v-container
        >

        <SoliResponsiveDialog
            ref="selection"
            @reset="[(selects[selection].show = false), (selection = null)]"
            v-if="selection"
            :close="false"
            ><template #body>
                <div class="px-0" :class="{ 'py-3': $vuetify.breakpoint.xs }">
                    <component
                        :is="selects[selection].comp"
                        v-bind="{ ...selects[selection].props() }"
                        v-model="form[selection]"
                        @input="resetOptions()"
                    ></component></div
            ></template>
        </SoliResponsiveDialog>
    </div>
</template>

<script>
import GlobalMoment from "../../../Mixins/GlobalMoment";
import BookingAPIs from "../../../Mixins/Booking/BookingAPIs";
import BookingAlerts from "../../../Mixins/Booking/BookingAlerts";

export default {
    mixins: [GlobalMoment, BookingAPIs, BookingAlerts],
    props: {
        errors: {
            type: Object,
            default: () => {},
        },
        locations: {
            type: Array,
            default: () => [],
        },
        instrument: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            selection: null,
            speedDial: false,
            simStudentView: true,
            form: {
                instrument: null,
                location: this.$page.props.auth.user.selected_location,
                date: null,
                duration: 30,
                repeating: false,
                type: {
                    name: "Assessment",
                    originalType: "Assessment",
                    recurring: false,
                    disabled: false,
                    assessment: true,
                    pending: false,
                },
            },
            selects: {
                instrument: {
                    name: "instrument",
                    clearable: false,
                    show: false,
                    display: () => this.form.instrument?.name ?? "Instrument",
                    comp: "SoliInstruments",
                    props: () => ({
                        hideDetails: true,
                        iterator: true,
                        autofocus: true,
                        //parentInstruments: this.instruments,
                    }),
                },
                online: {
                    name: "online",
                    clearable: false,
                    show: false,
                    display: () => (this.form.online ? "Online" : "In-Studio"),
                    comp: "SoliOnline",
                    props: () => ({
                        location: this.location,
                    }),
                },
                duration: {
                    name: "duration",
                    clearable: false,
                    show: false,
                    display: () =>
                        this.form.duration
                            ? this.form.duration + " min"
                            : "30 min",
                    disabled: false,
                    comp: "SoliDuration",
                    props: () => ({
                        filter: [15, 90],
                    }),
                },
            },
        };
    },
    methods: {
        selectDate(date) {
            this.form.startDate = date;
            this.$_apis_getAssignmentOpenings(this.simStudentView);
        },
        selectTime(event) {
            console.log(event);
        },
        resetOptions() {
            this.assignmentIntervals = null;
            this.$_apis_getAssignments(this.simStudentView);

            if (this.form.startDate) {
                this.form.startDate = null;
                this.searchAssignments = [];
            }
            this.closeDialogs();
        },
        closeDialogs() {
            if (!this.$refs.selection) return;
            this.$refs.selection.show = false;

            this.closeModal(() => {
                this.selects[this.selection].show = false;
                this.selection = null;
            });
        },
    },
};
</script>
